import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  centered: {
    textAlign: "center",
    marginTop: "80px",
  },
  heading: {
    marginBottom: "4px",
    fontWeight: 400,
    fontSize: "14px",
    color: semanticColors.foreground.secondary,
  },
  description: {
    fontWeight: 400,
    fontSize: "12px",
    marginBottom: "24px",
    paddingLeft: "16px",
    paddingRight: "16px",
    color: semanticColors.foreground.secondary,
  },
  documentationIcon: {
    width: "40px",
    height: "40px",
    fill: semanticColors.foreground.secondary,
    color: semanticColors.foreground.secondary,
    marginBottom: "8px",
    transform: "rotate(13.25deg)",
  },
});
